import { Injectable } from "@angular/core";
import { AuthApiService, LoginVO, TeilnehmerApiService, UserInfoVO } from "@core/api/v1";
import { NotificationService } from "@core/services/notification/notification.service";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class LoginService {
    private isLoggedInDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    isLoggedIn: Observable<boolean> = this.isLoggedInDataSubject.asObservable();

    private isRefreshedDataSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    isRefreshed: Observable<boolean> = this.isRefreshedDataSubject.asObservable();

    constructor(private authApiService: AuthApiService, private teilnehmerService: TeilnehmerApiService, private notificationService: NotificationService) {
        this.isLoggedInDataSubject.next(this.holeEingeloggtenUser());
    }


    login(loginVO: LoginVO) {

        this.authApiService.login(loginVO).subscribe(response => {
            if (response.userInfo?.id) {
                localStorage.setItem("loggedInUser", JSON.stringify(response.userInfo));
                this.isLoggedInDataSubject.next(true);

                return response;
            }
            console.log(response);
            return null;
        }, (error) => {
            this.notificationService.showError(JSON.parse(error.error).message);
        });


    }

    logout() {
        localStorage.clear();
        this.isLoggedInDataSubject.next(false);
        this.authApiService.logout().subscribe(response => {
        });
    }

    holeEingeloggtenUser(): UserInfoVO {
        let jsonObject = localStorage.getItem("loggedInUser") as string;
        return JSON.parse(jsonObject) as UserInfoVO;
    }

    refreshUser() {
        this.teilnehmerService.holeTeilnehmer().subscribe((response) => {
            let userInfoVo: UserInfoVO = {
                id: response.id,
                username: response.emailAdresse,
                anrede: response.anrede,
                vorname: response.vorname,
                nachname: response.nachname,
                vorgestellterTitel: response.vorgestellterTitel,
                nachgestellterTitel: response.nachgestellterTitel,
            }

            localStorage.setItem("loggedInUser", JSON.stringify(userInfoVo));
            this.isRefreshedDataSubject.next(true);
        })
    }
}
